"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AddIcon", {
  enumerable: true,
  get: function get() {
    return _AddIcon.default;
  }
});
Object.defineProperty(exports, "AnalyticsIcon", {
  enumerable: true,
  get: function get() {
    return _AnalyticsIcon.default;
  }
});
Object.defineProperty(exports, "AnalyticsSimpleIcon", {
  enumerable: true,
  get: function get() {
    return _AnalyticsSimpleIcon.default;
  }
});
Object.defineProperty(exports, "BrandingIcon", {
  enumerable: true,
  get: function get() {
    return _BrandingIcon.default;
  }
});
Object.defineProperty(exports, "BrandingSimpleIcon", {
  enumerable: true,
  get: function get() {
    return _BrandingSimpleIcon.default;
  }
});
Object.defineProperty(exports, "CheckboxCheckedIcon", {
  enumerable: true,
  get: function get() {
    return _CheckboxCheckedIcon.default;
  }
});
Object.defineProperty(exports, "CheckboxUncheckedIcon", {
  enumerable: true,
  get: function get() {
    return _CheckboxUncheckedIcon.default;
  }
});
Object.defineProperty(exports, "CheckIcon", {
  enumerable: true,
  get: function get() {
    return _CheckIcon.default;
  }
});
Object.defineProperty(exports, "CollapseIcon", {
  enumerable: true,
  get: function get() {
    return _CollapseIcon.default;
  }
});
Object.defineProperty(exports, "DashboardIcon", {
  enumerable: true,
  get: function get() {
    return _DashboardIcon.default;
  }
});
Object.defineProperty(exports, "DownArrowIcon", {
  enumerable: true,
  get: function get() {
    return _DownArrowIcon.default;
  }
});
Object.defineProperty(exports, "DownloadIcon", {
  enumerable: true,
  get: function get() {
    return _DownloadIcon.default;
  }
});
Object.defineProperty(exports, "EditIcon", {
  enumerable: true,
  get: function get() {
    return _EditIcon.default;
  }
});
Object.defineProperty(exports, "ExpandIcon", {
  enumerable: true,
  get: function get() {
    return _ExpandIcon.default;
  }
});
Object.defineProperty(exports, "GroupsIcon", {
  enumerable: true,
  get: function get() {
    return _GroupsIcon.default;
  }
});
Object.defineProperty(exports, "HomeIcon", {
  enumerable: true,
  get: function get() {
    return _HomeIcon.default;
  }
});
Object.defineProperty(exports, "InfoIcon", {
  enumerable: true,
  get: function get() {
    return _InfoIcon.default;
  }
});
Object.defineProperty(exports, "KeyIcon", {
  enumerable: true,
  get: function get() {
    return _KeyIcon.default;
  }
});
Object.defineProperty(exports, "LeftArrowIcon", {
  enumerable: true,
  get: function get() {
    return _LeftArrowIcon.default;
  }
});
Object.defineProperty(exports, "LockedIcon", {
  enumerable: true,
  get: function get() {
    return _LockedIcon.default;
  }
});
Object.defineProperty(exports, "MagnifyingGlassIcon", {
  enumerable: true,
  get: function get() {
    return _MagnifyingGlassIcon.default;
  }
});
Object.defineProperty(exports, "PrinterIcon", {
  enumerable: true,
  get: function get() {
    return _PrinterIcon.default;
  }
});
Object.defineProperty(exports, "ProfileIcon", {
  enumerable: true,
  get: function get() {
    return _ProfileIcon.default;
  }
});
Object.defineProperty(exports, "RestoreIcon", {
  enumerable: true,
  get: function get() {
    return _RestoreIcon.default;
  }
});
Object.defineProperty(exports, "RightArrowIcon", {
  enumerable: true,
  get: function get() {
    return _RightArrowIcon.default;
  }
});
Object.defineProperty(exports, "ScrollToTopIcon", {
  enumerable: true,
  get: function get() {
    return _ScrollToTopIcon.default;
  }
});
Object.defineProperty(exports, "TrashIcon", {
  enumerable: true,
  get: function get() {
    return _TrashIcon.default;
  }
});
Object.defineProperty(exports, "UnlockedIcon", {
  enumerable: true,
  get: function get() {
    return _UnlockedIcon.default;
  }
});
Object.defineProperty(exports, "UpArrowIcon", {
  enumerable: true,
  get: function get() {
    return _UpArrowIcon.default;
  }
});
Object.defineProperty(exports, "UsersIcon", {
  enumerable: true,
  get: function get() {
    return _UsersIcon.default;
  }
});
Object.defineProperty(exports, "UsersSimpleIcon", {
  enumerable: true,
  get: function get() {
    return _UsersSimpleIcon.default;
  }
});
Object.defineProperty(exports, "WarningIcon", {
  enumerable: true,
  get: function get() {
    return _WarningIcon.default;
  }
});
exports.default = void 0;

var _Icon = _interopRequireDefault(require("./Icon"));

var _AddIcon = _interopRequireDefault(require("./icons/AddIcon"));

var _AnalyticsIcon = _interopRequireDefault(require("./icons/AnalyticsIcon"));

var _AnalyticsSimpleIcon = _interopRequireDefault(require("./icons/AnalyticsSimpleIcon"));

var _BrandingIcon = _interopRequireDefault(require("./icons/BrandingIcon"));

var _BrandingSimpleIcon = _interopRequireDefault(require("./icons/BrandingSimpleIcon"));

var _CheckboxCheckedIcon = _interopRequireDefault(require("./icons/CheckboxCheckedIcon"));

var _CheckboxUncheckedIcon = _interopRequireDefault(require("./icons/CheckboxUncheckedIcon"));

var _CheckIcon = _interopRequireDefault(require("./icons/CheckIcon"));

var _CollapseIcon = _interopRequireDefault(require("./icons/CollapseIcon"));

var _DashboardIcon = _interopRequireDefault(require("./icons/DashboardIcon"));

var _DownArrowIcon = _interopRequireDefault(require("./icons/DownArrowIcon"));

var _DownloadIcon = _interopRequireDefault(require("./icons/DownloadIcon"));

var _EditIcon = _interopRequireDefault(require("./icons/EditIcon"));

var _ExpandIcon = _interopRequireDefault(require("./icons/ExpandIcon"));

var _GroupsIcon = _interopRequireDefault(require("./icons/GroupsIcon"));

var _HomeIcon = _interopRequireDefault(require("./icons/HomeIcon"));

var _InfoIcon = _interopRequireDefault(require("./icons/InfoIcon"));

var _KeyIcon = _interopRequireDefault(require("./icons/KeyIcon"));

var _LeftArrowIcon = _interopRequireDefault(require("./icons/LeftArrowIcon"));

var _LockedIcon = _interopRequireDefault(require("./icons/LockedIcon"));

var _MagnifyingGlassIcon = _interopRequireDefault(require("./icons/MagnifyingGlassIcon"));

var _PrinterIcon = _interopRequireDefault(require("./icons/PrinterIcon"));

var _ProfileIcon = _interopRequireDefault(require("./icons/ProfileIcon"));

var _RestoreIcon = _interopRequireDefault(require("./icons/RestoreIcon"));

var _RightArrowIcon = _interopRequireDefault(require("./icons/RightArrowIcon"));

var _ScrollToTopIcon = _interopRequireDefault(require("./icons/ScrollToTopIcon"));

var _TrashIcon = _interopRequireDefault(require("./icons/TrashIcon"));

var _UnlockedIcon = _interopRequireDefault(require("./icons/UnlockedIcon"));

var _UpArrowIcon = _interopRequireDefault(require("./icons/UpArrowIcon"));

var _UsersIcon = _interopRequireDefault(require("./icons/UsersIcon"));

var _UsersSimpleIcon = _interopRequireDefault(require("./icons/UsersSimpleIcon"));

var _WarningIcon = _interopRequireDefault(require("./icons/WarningIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _Icon.default;
exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/Icon/index.js